import { render, staticRenderFns } from "./DefaultAboutShop.vue?vue&type=template&id=d1d46b42&scoped=true&"
import script from "./DefaultAboutShop.vue?vue&type=script&lang=js&"
export * from "./DefaultAboutShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d46b42",
  null
  
)

export default component.exports